import DetectRTC from 'detectrtc';
import { useConfirmationModal } from 'src/components/ConfirmationModal';
import { useGatheringPermissions } from 'src/hooks/useGatheringPermissions';
import { useLocales } from 'src/locales';
import { HasPermissionActionIcon } from './HasPermissionActionIcon';

type Props = {
  isSpeaking?: boolean;
  muted: boolean;
  setMuted: (mute: boolean) => void;
};

export const ToggleMicControl = ({ isSpeaking, muted, setMuted }: Props) => {
  const { translate } = useLocales();
  const { confirm } = useConfirmationModal();

  const { hasMicrophone, audioPermission, grantPermission } =
    useGatheringPermissions();

  const askPermission = async () => {
    if (audioPermission === 'denied') {
      await confirm({
        title: translate('communicate.rtc_controls.permission_denied_title'),
        message: translate('communicate.rtc_controls.permission_denied_button'),
        cancelButton: false,
        confirmText: 'OK',
      });
      return;
    }
    await grantPermission(DetectRTC.hasWebcam);
  };

  return (
    <HasPermissionActionIcon
      tooltip={
        muted
          ? translate('communicate.rtc_controls.unmute_microphone')
          : translate('communicate.rtc_controls.mute_microphone')
      }
      onClick={() => setMuted(!muted)}
      isActive={!muted}
      isEnabled={!!isSpeaking}
      inactiveIcon="tabler:microphone-off"
      activeIcon="tabler:microphone"
      hasPermission={hasMicrophone}
      askPermission={askPermission}
    />
  );
};
